import {
  generalAdabyronBehaviour,
  USER_TYPES,
} from '../../utils/adaByron';
import {
  MethodType,
  UnknownObject,
  Context,
} from '../../utils/types';

export enum PATHS {
  REGISTER_SHOPPER = 'datoscliente/registrar',
  VALIDATE_SHOPPER = 'datoscliente/validar',
  IS_REGISTERED_SHOPPER = 'datoscliente/registrado',
  DELETE_SHOPPER = 'datoscliente/reiniciar',
}

type ContactMean = Array<{
  value: string;
  contactTypeTCOL: string;
  sendOTP: boolean;
}>;
export const registerShopper = (
  data: {
    clientName: string;
    firstSurName: string;
    secondSurName: string;
    companyName: string;
    documentType: string;
    documentNumber: string;
    nationality: string;
    contactMeans: ContactMean;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const {
    clientName,
    firstSurName,
    secondSurName,
    companyName,
    documentType,
    documentNumber,
    nationality,
    contactMeans,
  } = data;

  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.REGISTER_SHOPPER,
    userTypes: [USER_TYPES.OPEN],
    eventName: 'REGISTER.REGISTER_SHOPPER',
    mockedInfo: 'registerShopper',
    methodType: MethodType.POST,
    requestObject: {
      name: clientName,
      firstSurName,
      secondSurName,
      companyName,
      documentType,
      documentNumber: documentNumber.toUpperCase(),
      nationality,
      contactMeans,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const validateShopper = (
  data: {
    pin: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { pin } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.VALIDATE_SHOPPER,
    userTypes: [USER_TYPES.OPEN],
    eventName: 'REGISTER.VALIDATE_SHOPPER',
    mockedInfo: 'validateShopper',
    methodType: MethodType.POST,
    requestObject: {
      pin,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const isRegisteredShopper = (
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.IS_REGISTERED_SHOPPER,
    userTypes: [USER_TYPES.OPEN],
    eventName: 'REGISTER.IS_REGISTERED_SHOPPER',
    mockedInfo: 'isRegisteredShopper',
    methodType: MethodType.GET,
    onSuccessCallback: (xhr: XMLHttpRequest): UnknownObject => {
      const { response } = xhr;
      const datos = JSON.parse(response);
      return datos;
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const deleteShopper = (
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.DELETE_SHOPPER,
    userTypes: [USER_TYPES.OPEN],
    eventName: 'REGISTER.DELETE_SHOPPER',
    mockedInfo: 'deleteShopper',
    methodType: MethodType.POST,
    onSuccessCallback: (xhr: XMLHttpRequest): UnknownObject => {
      const { response } = xhr;
      const datos = JSON.parse(response);
      return datos;
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};
